export default function App() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-950">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="relative rounded-2xl overflow-hidden">
          {/* Background */}
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=A%20dark%20atmospheric%20abstract%20image%20with%20deep%20crimson%20and%20charcoal%20gradients%2C%20dramatic%20lighting%2C%20sophisticated%20editorial%20style%2C%20warm%20glow%20accents%2C%20no%20text%2C%20no%20people&width=1600&height=600&seq=app-bg-91hl&orientation=landscape"
              alt=""
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-background-950/80"></div>
          </div>

          {/* Content */}
          <div className="relative z-10 flex flex-col lg:flex-row items-center gap-8 md:gap-12 p-8 md:p-12 lg:p-16">
            {/* Left: Text */}
            <div className="flex-1 text-center lg:text-left">
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-500/15 border border-accent-500/30 text-accent-400 text-xs font-medium mb-4">
                <i className="ri-download-line"></i>
                即将上线
              </span>
              <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-50 mb-4">
                91黑料<span className="text-primary-400">APP</span>
              </h2>
              <p className="text-sm md:text-base text-foreground-400 leading-relaxed mb-6 max-w-[480px] mx-auto lg:mx-0">
                随时随地吃瓜围观，推送快人一步。支持iOS与Android双平台，享受更流畅的91黑料吃瓜在线体验。黑料吃瓜最新爆料，手机一键直达。
              </p>

              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <button className="w-full sm:w-auto flex items-center justify-center gap-2 px-6 py-3 rounded-lg bg-foreground-100 hover:bg-foreground-200 text-background-950 font-semibold text-sm transition-all duration-200 whitespace-nowrap cursor-pointer">
                  <i className="ri-apple-line text-lg"></i>
                  App Store
                </button>
                <button className="w-full sm:w-auto flex items-center justify-center gap-2 px-6 py-3 rounded-lg bg-primary-500/15 border border-primary-500/30 hover:bg-primary-500/25 text-primary-400 font-semibold text-sm transition-all duration-200 whitespace-nowrap cursor-pointer">
                  <i className="ri-android-line text-lg"></i>
                  Android 下载
                </button>
              </div>

              <p className="mt-4 text-xs text-foreground-600">扫码或点击下载，立即开启移动吃瓜之旅</p>
            </div>

            {/* Right: Phone mock */}
            <div className="shrink-0 relative">
              <div className="w-[200px] h-[400px] md:w-[240px] md:h-[480px] rounded-[2rem] border-4 border-background-700/60 bg-background-800/50 overflow-hidden">
                <div className="w-full h-full flex flex-col items-center justify-center p-6">
                  <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-primary-500 text-background-950 font-heading font-bold text-2xl mb-4">
                    91
                  </div>
                  <p className="font-heading text-lg font-bold text-foreground-200">黑料</p>
                  <p className="text-xs text-foreground-500 mt-2 text-center">吃瓜爆料 · 精彩不停</p>
                  <div className="mt-6 w-full space-y-2">
                    {['🔥 实时热榜', '📰 最新快讯', '💬 瓜友社区', '🎬 视频专区'].map((item) => (
                      <div key={item} className="px-3 py-2 rounded-lg bg-background-900/50 text-xs text-foreground-400">
                        {item}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              {/* Decorative glow */}
              <div className="absolute -inset-4 bg-primary-500/5 rounded-[3rem] blur-2xl -z-10"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}